import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=3ca4a558&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"
import style0 from "./ProductsList.vue?vue&type=style&index=0&id=3ca4a558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca4a558",
  null
  
)

export default component.exports